import { useState } from 'react';

type UseDisclosureReturnType = {
  isOpen: boolean;
  open: () => void;
  close: () => void;
  toggle: () => void;
};

const useDisclosure = (initialState = false): UseDisclosureReturnType => {
  const [isOpen, setIsOpen] = useState(initialState);

  const open = () => {
    setIsOpen(true);
  };

  const close = () => {
    setIsOpen(false);
  };

  const toggle = () => {
    setIsOpen((prevIsOpen) => !prevIsOpen);
  };

  return {
    isOpen,
    open,
    close,
    toggle,
  };
};

export default useDisclosure;
